<!--协议弹框-->
<template>
	<div class='agreement-dialog'>
		<el-dialog
				title="保密协议"
				:visible.sync="dialogVisible"
				width="30%"
				:before-close="handleCloseDialog">
			<div class="agreement-content" v-html="agreement_content"></div>
			<div class="agreement-operation" slot="footer">
				<el-checkbox v-model="agreement_checked">阅读并勾选接单保密协议</el-checkbox>
				<button
						:disabled="!agreement_checked"
						:class="agreement_checked ? 'lg-yellow-btn':'lg-yellow-btn is_disabled'"
						@click="handleSubmitAgree"
				>
					确定
				</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        // 弹框状态
        dialogVisible: false,
        // 多选框
        agreement_checked: false,
        // 协议内容
        agreement_content: "",
        // 订单id
        order_id: ""
      }
    },
    mounted() {
      this.$requestApi.index.webInfo().then(res => {
        for (const key in res.data) {
          if (res.data[key].menu_name === 'secret_agreement') {
            this.$requestApi.index.pageDetail(res.data[key].value).then(res => this.agreement_content = res.data.content)
          }
        }
      })

    },
    methods: {
      handleOpenDialog(data) {
        this.dialogVisible = true
        this.order_id = data
      },
      handleCloseDialog() {
        this.dialogVisible = false
        this.agreement_checked = false
      },
      handleSubmitAgree() {
        this.$requestApi.task.applyOrder(this.order_id).then(res => {
          this.$Bus.$emit('uploadOrder')
          this.dialogVisible = false
          this.$Bus.$emit('tips', '提示', '您已申请成功，请耐心等待！')
        })
      }
    }
  }
</script>

<style scoped lang='less'>
	.agreement-dialog {
		/deep/ .el-dialog__wrapper {
			.el-dialog__header {
				background-color: #ffffff;
				padding: 10px 20px;
				border-bottom: 1px solid #F4F4F4;

				.el-dialog__title {
					font-size: 16px;
				}

				.el-dialog__headerbtn {
					top: 13px;
				}

				.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
					color: #ffde00;
				}
			}

			.el-dialog__body {
				padding-bottom: 0;
			}

			.el-dialog__footer {
				border-top: 1px solid #F4F4F4;
				padding-bottom: 10px;
			}
		}

		.agreement-content {
			height: 500px;
			overflow-y: scroll;

			/deep/ * {
				margin: 15px 0;
				line-height: 30px;
			}

			/deep/ li {
				margin-left: 20px;
				list-style: initial;
			}
		}

		.agreement-operation {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.is_disabled {
				background-color: #F4F4F4;
				color: #333333;
			}

			/deep/ .el-checkbox {
				.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
					background-color: #ffde00;
					border-color: #ffde00;
				}

				.el-checkbox__input.is-checked + .el-checkbox__label {
					color: #ffde00;
				}

				.el-checkbox__inner:hover {
					border-color: #ffde00;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/agreementDialog/index.vue